// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

/* 引入aos动画库相关文件 */
import AOS from 'aos'
import 'aos/dist/aos.css'

/* aos动画初始化 */
AOS.init({
  duration: 500,
  once: true,
  easing: 'ease-in-out-back'
})

Vue.config.productionTip = false

Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js